export { default as translations } from './translations.json';

/**
 * Check if listing has active spotlight.
 * @param {Object|null} listing
 * @param {Date} [now]
 * @returns {boolean}
 */
export const isSpotlightActive = (listing, now = new Date()) => {
  const spotlight = listing?.attributes?.metadata?.spotlight;
  if (!spotlight?.active) return false;
  return new Date(spotlight.expiresAt) > now;
};

export const getSpotlight = (listing) =>
  listing?.attributes?.metadata?.spotlight || null;

/**
 * Calculate spotlight cost.
 * @param {number} days
 * @param {number} pricePerDayCents
 * @returns {number}
 */
export const calculateSpotlightCost = (days, pricePerDayCents) =>
  days * pricePerDayCents;
